export const COLORS = {
    main: "#0f0f1a",
    white: "#ffffff",
    yellowLow: "#f3dcdc",
    orange: "#f5bcba",
    purpleLow: "#e3aadd",
    purple: "#c8a8e9",
    blueLow: "#c3c7f3",
    black: "#636363",
    footer:"#1f2937",
    grey: "#e8e8e8",
    danger: "#fb5656",
    gold: "#fcff73",
    green: "#2fac66",
    greenDark:"#2c754c",
    prix: "#ff9800",
    border_and_text_blue:"#00ffcc",
    gris:"#9c9c9c",
    blue_sky:"#a0fdfd",
    blue_marine_low: "#1f1f2e",
    orange_new:"#ff9800",
    freebg:"#002f2f",
}